import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

// What a lookbook may hold, read rather than hardcoded so the number lives in one place across
// the clients and the backend.
function* getLookbookLimits({ payload: { signal } = {} }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.limits, signal });

    yield put(actions.getLookbookLimitsDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLookbookLimitsFailed,
      endpoint: api.lookbooks.limits.url
    });
  }
}

export const getLookbookLimitsSaga = takeEvery(types.GET_LOOKBOOK_LIMITS_REQUEST, getLookbookLimits);
